module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-buttons"
  }, [(_vm.genericMessage) ? _c('div', {
    staticClass: "card-btn__copy",
    domProps: {
      "innerHTML": _vm._s(_vm.genericMessage)
    }
  }, [_vm._v("\n        Join SK Club now to activate your SK Club\n        Standard Bank 4for3 Benefit.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.moreInfoLink) ? _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "tag": "a",
      "href": _vm.moreInfoLink,
      "target": "_blank"
    }
  }, [_vm._v("More Info")])], 1) : _vm._e(), _vm._v(" "), (_vm.activationLink) ? _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "tag": "a",
      "href": _vm.activationLink,
      "target": "_blank"
    }
  }, [_vm._v("Activate\n        ")])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac5233c0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/card/card-generic.vue
// module id = 885
// module chunks = 0